import React from "react";
import Radium from "radium";
import InfoIcon from "material-ui/svg-icons/action/info";

const ROOT_STYLE = {
  position: "relative",
  display: "inline-block",
  ":hover": {}
};

const ICON_STYLE = {
  verticalAlign: -4,
  color: "rgba(0,0,0,0.4)",
  height: 16,
  width: 16,
  minWidth: 16,
  marginRight: 4
};

const TOOLTIP_STYLE = {
  position: "absolute",
  fontSize: 10,
  lineHeight: "22px",
  padding: "0px 8px",
  zIndex: 1200,
  color: "rgb(255, 255, 255)",
  backgroundColor: "rgb(97, 97, 97)",
  overflow: "hidden",
  top: 20,
  left: 20,
  opacity: 0,
  borderRadius: 2,
  transition: "top 0.1s ease, opacity 0.1s ease",
  whiteSpace: "nowrap",
  pointerEvents: "none"
};

const SHOWN_STYLE = {
  opacity: 0.9,
  top: 0,
  pointerEvents: "auto"
};

class InfoTooltip extends React.Component {
  render() {
    const { text } = this.props;

    return (
      <div key="root" style={ROOT_STYLE}>
        <InfoIcon style={ICON_STYLE} />
        <div
          style={[
            TOOLTIP_STYLE,
            Radium.getState(this.state, "root", ":hover") && SHOWN_STYLE
          ]}
        >
          {text}
        </div>
      </div>
    );
  }
}

export default Radium(InfoTooltip);



// WEBPACK FOOTER //
// ./src/app/components/partials/info-tooltip.jsx